module.exports = __webpack_public_path__ + "static/media/bk.2127bd36.svg";